import PropTypes from 'prop-types';
import React, {useState} from 'react';
import headerClasses from 'src/pages/category/components/header.module.scss';
import {Icon} from 'src/pages/category/components/Icon';
import {
  background,
  collectionLinks,
} from 'src/pages/category/components/style.module.scss';
import {Topics} from 'src/pages/category/components/Topics';
import {Link} from 'src/shared/components/Link';
import {PageFooter} from 'src/shared/components/PageFooter';
import {StatefulHeader} from 'src/shared/components/StatefulHeader';
import {SubNav} from 'src/shared/components/SubNav';
import {home} from 'src/shared/pagePaths';
import {mainWide} from 'src/styles/modules/main.module.scss';
import {ModalCarousel} from 'src/pages/category/components/ModalCarousel';
import {chat} from '../../contactUs/components/Chat/propTypes';

const {categoryBackgrounds} = headerClasses;

export const CategoryPage = ({
  category: {
    breadcrumb,
    collectedLinks,
    path,
    subtitle,
    title,
    topics,
    wifiTipsAndTricks,
  },
  selectedTopic,
  selectedSubtopic,
  onChangeTopics,
  launchXfinityAssistant,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = event => {
    event.preventDefault();
    setModalOpen(true);
  };

  const closeModal = event => {
    event.preventDefault();
    setModalOpen(false);
  };

  return (
    <>
      <SubNav
        breadcrumbs={[
          {href: home(), text: 'Support'},
          {href: window.location.href.replace(window.location.hash, ''), text: breadcrumb},
        ]}
      />
      <div className={background}>
        <StatefulHeader
          className={`${categoryBackgrounds} ${headerClasses?.[path] ?? headerClasses.defaultStyle}`}
          headline={title}
          tagline={subtitle}
        >
          <div className={collectionLinks}>
            {
              collectedLinks.map(({icon, link}) => (
                <Link key={link.text} openModal={openModal} {...link}><Icon icon={icon} /> {link.text}</Link>
              ))
            }
          </div>
        </StatefulHeader>
        {isModalOpen && <ModalCarousel slides={wifiTipsAndTricks} onCloseModal={closeModal} launchXfinityAssistant={launchXfinityAssistant} />}
        <main className={mainWide}>
          <Topics
            onChangeTopics={onChangeTopics}
            selectedSubtopic={selectedSubtopic}
            selectedTopic={selectedTopic}
            topics={topics}
          />
        </main>
      </div>
      <PageFooter />
    </>
  );
};

CategoryPage.propTypes = {
  category: PropTypes.shape({
    background: PropTypes.string,
    breadcrumb: PropTypes.string,
    path: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    collectedLinks: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.string,
      link: PropTypes.shape({
        href: PropTypes.string.isRequired,
        target: PropTypes.oneOf(['_self', '_blank', '_top']),
        text: PropTypes.string.isRequired,
      }),
    })),
    topics: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      subtopics: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        links: PropTypes.arrayOf(PropTypes.shape({
          href: PropTypes.string.isRequired,
          target: PropTypes.oneOf(['_self', '_blank', '_top']),
          text: PropTypes.string.isRequired,
        })),
      })),
    })),
    wifiTipsAndTricks: PropTypes.array,
  }).isRequired,
  onChangeTopics: PropTypes.func.isRequired,
  selectedSubtopic: PropTypes.object,
  selectedTopic: PropTypes.object,
  launchXfinityAssistant: chat.launchXfinityAssistant,
};
